/**
 * Enum sử dụng danh mục
 * nnduc 16/02/2024
 */
export default {
  All: null,
  Used: true,
  Stoped: false,
};
